





<template>
  <div v-if="memorialHallModel" class="worshipPage" :style="'height:'+fullHeight+'px;'">
    <!-- header start -->
    <van-nav-bar
      :title="memorialHallModel.MemorialHallSearchApiModel.Title + '墓园'"
      class="mynavbar"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
      <!-- <template #right>
        <van-icon name="share" @click="shareHandler" />
      </template> -->
    </van-nav-bar>
    <!-- header end -->
    <!-- 背景图 -->
    <img v-if="qimg" :src="qimg" class="worshipBg" />


    <section
      class="gift-section"
      :style="{backgroundImage:`url('${(himg)}')`}"
    >
      <div class="box">
        <!-- 双人头像 -->
        <section
          class="touxiang-double"
          v-if="memorialHallModel && memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList.length > 1"
        >
          <div
            class="item"
            v-for="item in memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList"
            :key="item.Id"
          >
            <div class="avatar">
              <van-image width="100%" height="100%" fit="cover" :src="item.HeadPhoto" />
            </div>
            <P class="name">{{item.DeceasedName}}</P>
            <P class="date">
              {{item.OutPutBirthdayDateDesc.length > 4 ? item.OutPutBirthdayDateDesc.substring(0, 4):item.OutPutBirthdayDateDesc}}
              -
              {{item.OutPutPassAwayDateDesc.length > 4 ? item.OutPutPassAwayDateDesc.substring(0, 4):item.OutPutPassAwayDateDesc}}
            </P>
          </div>
        </section>
        <!-- 单人头像 -->
        <section class="touxiang-single" v-else-if="memorialHallModel">
          <div class="avatar">
            <van-image
              width="100%"
              height="100%"
              fit="cover"
              :src="memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].HeadPhoto"
            />
          </div>
          <P
            class="name"
          >{{memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].DeceasedName}}</P>
          <P class="date">
            {{memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc.length > 4 ? memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc.substring(0, 4):memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc}}
            -
            {{memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc.length > 4 ? memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc.substring(0, 4):memorialHallModel.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc}}
          </P>
        </section>
        
      </div>
    </section>

  </div>
</template>

<script>
import soshm from "soshm";
import placeTypeStatus from "@/static/sacrificePlaceTypeStatus";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      fullHeight: document.documentElement.clientHeight,
      showNumber: 1,
      mid: 0,
      muid: "",
      placeType: 0,
      memorialHallModel: null,
      showimg: "",
      qimg:null,
      himg:null,
    };
  },
  computed: {
    ...mapGetters(["currentToken"])
  },
  watch: {
    fullHeight(val) {
      //监控浏览器高度变化
      if (!this.timer) {
        this.fullHeight = val;
        this.timer = true;
        let that = this;
        setTimeout(function() {
          that.timer = false;
        }, 400);
      }
    }
  },
  mounted() {
    this.get_bodyHeight();
  },
  methods: {
    get_bodyHeight() {
      //动态获取浏览器高度
      const that = this;
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          that.fullHeight = window.fullHeight;
        })();
      };
    },
    get() {
      this.isMovegift = false;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    /**推荐给朋友**/
    shareHandler() {
      // soshm.popIn({
      //   title: "弹窗分享",
      //   sites: ["weixin", "weixintimeline", "weibo", "qzone", "tqq", "qq"]
      // });
    },
    init() {
      var that = this;
      this.getData();
    },
    getData() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetMourningHallMourningHallSearch",
          Id: that.mid,
          PlaceType: that.placeType
        })
        .then(
          res => {
            that.memorialHallModel = res;
            if (
              res.SacrificeLogIncenseList &&
              res.SacrificeLogIncenseList.length > 0
            ) {
              res.SacrificeLogIncenseList.map(e => {
                that.incensePic = e.AppSacrifice.SacrificePath;
                that.incenseLogId = e.SerialNumber;
              });
            }
          },
          err => {}
        );
    },
  },
  created() {
    var that = this;
    this.mid = this.$store.state.mid;
    this.muid = this.$store.state.muid;
    this.placeType = placeTypeStatus.Cemetery;
    this.qimg = this.$route.query.qimg;
    this.himg = this.$route.query.himg;
    this.init();
    // this.getShowImg();
  }
};
</script>

<style scoped>
.worshipPage {
  width: 100%;
  overflow: hidden;
  position: relative;
  background-color: #000;
}
.worshipBg {
  position: absolute;
  width: 100%;
  height: auto;
  object-fit: cover;
}
.mynavbar {
  background-color: rgba(0, 0, 0, 0.5) !important;
}
.left-cate-box {
  position: absolute;
  left: 8px;
  top: 66px;
  z-index: 9;
}
.right-cate-box {
  position: absolute;
  right: 8px;
  top: 66px;
  z-index: 9;
}
.cate-item {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 4px;
  margin-bottom: 10px;
  width: 50px;
  height: 50px;
}
.cate-item > .icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.cate-item > .num {
  font-size: 10px;
  color: yellow;
}
.touxiang-single {
  position: relative;
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.touxiang-single .avatar {
  width: 30px;
  height: 42px;
}
.touxiang-single .name {
  font-size: 12px;
  color: orange;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 8px;
}
.touxiang-single .date {
  font-size: 12px;
  color: orange;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.6);
}
.touxiang-double {
  position: relative;
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.touxiang-double .item {
  position: relative;
  width: 34px;
  margin: 0 1px;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.touxiang-double .item .avatar {
  width: 25px;
  height: 36px;
}
.touxiang-double .item .name {
  font-size: 12px;
  color: orange;
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.5);
}
.touxiang-double .item .date {
  font-size: 10px;
  color: orange;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  transform: scale(0.4);
}
.gift-section {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 368px;
  background: center center no-repeat;
  background-size: 100% 100%;
}
/* background: url({{memorialHallModel.Template.TombstoneImagePath}}) center center no-repeat; */
/* "~@/assets/images/worship/mubei.png" */
.gift-section > .box {
  position: relative;
  width: 100%;
  height: 100%;
}
.first-floor {
  position: absolute;
  bottom: 230px;
  left: 0;
  right: 0;
  width: 100%;
  height: 203px;
}
.first-floor-content {
  position: relative;
  width: 100%;
  height: 100%;
  bottom: 0;
  left: 0;
  right: 0;
}
.xianghuo {
  position: absolute;
  right: 0;
  left: 0;
  bottom: 0;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack {
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
}
.xianghuo .stack .lu {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 41px;
  height: auto;
  margin: auto;
  z-index: 10;
}
.xianghuo .stack .xiang {
  position: absolute;
  bottom: 21px;
  left: 0;
  right: 0;
  max-width: 41px;
  max-height: 60px;
  margin: auto;
  z-index: 9;
}
.lazhu-left {
  position: absolute;
  bottom: 0;
  left: 32%;
}
.lazhu-right {
  position: absolute;
  bottom: 0;
  right: 32%;
}
.lazhu {
  max-width: 38px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.lazhu img {
  max-width: 100%;
  max-height: 100%;
}
.hua-left {
  position: absolute;
  left: 24%;
}
.hua-right {
  position: absolute;
  right: 24%;
}
.hua {
  bottom: 2px;
  max-width: 46px;
  max-height: 88px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.hua img {
  max-width: 100%;
  max-height: 100%;
}
.packgage-floor {
  position: absolute;
  bottom: 80px;
  left: 0;
  right: 0;
}
.gift-floor {
  position: absolute;
  bottom: 152px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gift-floor img {
  max-width: 35px;
}
.tabBarBottmon {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  height: 50px;
}
.tabBarBottmon > .item {
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.tabBarBottmon > .item > .icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.tabBarBottmon > .item > .text {
  font-size: 10px;
  color: #fff;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-top: 2px;
}
.jibaiBtn {
  position: fixed;
  width: 74px;
  height: 74px;
  bottom: 10px;
  left: 50%;
  margin-left: -37px;
}
.jibaiBtn img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>
